import { Ace as AceNamespace } from 'ace-builds';
import { AceEditorTheme } from 'modules/aceEditor';
import { MutableRefObject, createContext, useContext } from 'react';

type JsonEditorContextState = {
  editor: MutableRefObject<AceNamespace.Editor | null>;
  aceEditorTheme: AceEditorTheme;
  redo: () => void;
  undo: () => void;
};

const JSON_EDITOR_CONTEXT_DEFAULT_VALUE: JsonEditorContextState = {
  editor: { current: null },
  aceEditorTheme: AceEditorTheme.Monokai,
  redo: () => null,
  undo: () => null,
};

export const JsonEditorContext = createContext(JSON_EDITOR_CONTEXT_DEFAULT_VALUE);
export const useJsonEditorContext = () => useContext(JsonEditorContext);
